export class TileIcon {
    fontIcon?: string;
    fontSet?: string;
    svgIcon?: string;
}

export interface ITileWithIcon {
    icon?: string;
    iconView?: TileIcon;
}
